const theme = {
  colors: {
    dark: '#313131',
    darkMedium: '#7c7c7b',
    darkLighter: '#aaaaaa',
  },
}

export { theme }
